export const UNEXPECTED = 501

export const FIREBASE_AUTH = 502

export const REQUEST = 503
